// src/auth/Auth0Binder.jsx
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { bindAuth0 } from "./auth0-bridge";

export default function Auth0Binder() {
  const {
    getAccessTokenSilently,
    getIdTokenClaims,
    loginWithRedirect,
    isAuthenticated,
    isLoading,
  } = useAuth0();

  useEffect(() => {
    bindAuth0({
      getAccessTokenSilently,
      getIdTokenClaims,
      loginWithRedirect,
      isAuthenticatedFn: () => !!isAuthenticated,
      isLoadingFn: () => !!isLoading,
    });
  }, [
    getAccessTokenSilently,
    getIdTokenClaims,
    loginWithRedirect,
    isAuthenticated,
    isLoading,
  ]);

  return null;
}
